<template>
	<div>
		<ModalEditMember ref="ModalEditMember" @resend="resend"></ModalEditMember>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Member Ecommerce</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent v-if="dropfilter" @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined >
			<v-data-table loading disable-pagination :headers="headers" :items="listMember" :search="search" hide-default-footer :options.sync="option" :server-items-length="paginationMember.total_data" class="table-w-120">
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on" @click.stop="editMember(item)">
								<v-icon dark>mdi-pencil</v-icon>
							</v-btn>
						</template>
						<span>Edit</span>
					</v-tooltip>
				</template>
				<template v-slot:item.member_network_mid="{ item }">
					<div class="pt-2">{{ item.member_network_mid }}</div>
				</template>
				<template v-slot:item.member_name="{ item }">
					<div class="pt-2">{{ item.member_name }}</div>
				</template>
				<template v-slot:item.member_mobilephone="{ item }">
					<div class="pt-2 text-uppercase">{{ item.member_mobilephone }}</div>
				</template>
				<template v-slot:item.member_email="{ item }">
					<div class="pt-2">{{ item.member_email }}</div>
				</template>
				<template v-slot:item.member_gender="{ item }">
					<div class="pt-2">{{ item.member_gender == 'female' ? 'Perempuan' : 'Laki-Laki' }}</div>
				</template>
				<template v-slot:item.member_birthdate="{ item }">
					<div class="pt-2">{{ item.member_birthdate | tanggalIna }}</div>
				</template>
				<template v-slot:item.member_input_datetime="{ item }">
					<div class="pt-2">{{ item.member_input_datetime | tanggalIna }}</div>
				</template>
				<!-- <template v-slot:item.member_is_active="{ item }">
					<div class="pt-2">{{ item.member_is_active == 1 ? 'Aktif' : 'Tidak Aktif' }}</div>
				</template> -->
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!paginationMember">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5" v-if="paginationMember">
			<v-row>
				<v-col cols="11" md="11" class="py-0 d-flex justify-space-between">
					<span>Total {{paginationMember.total_data | toNumber}} Data</span>
					<v-pagination v-model="page" :length="paginationMember.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="1" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import filterComponent from '@/components/Filter'
import ModalEditMember from './components/ModalEditMember'

const list_gender = [{
	value: 'male',
	text: 'Laki-Laki'
}, {
	value: 'female',
	text: 'Perempuan'
}];

// const list_status = [{
// 	value: 1,
// 	text: 'Aktif'
// }, {
// 	value: 0,
// 	text: 'Tidak Aktif'
// }];

export default {
	inject: ['theme'],
	components: {
		filterComponent, ModalEditMember
	},
	data() {
		return {
			sortBy: 'member_network_id',
			sortDir: 'DESC',
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Aksi', align: 'center', value: 'action'},
			{ text: 'Kode Member', align: 'start', value: 'member_network_mid'},
			{ text: 'Nama Member', align: 'start', value: 'member_name'},
			// { text: 'Status', value: 'member_is_active'},
			{ text: 'Nomor Handphone', value: 'member_mobilephone', sortable: false },
			{ text: 'Email', value: 'member_email'},
			{ text: 'Jenis Kelamin', value: 'member_gender'},
			{ text: 'Tanggal Lahir', value: 'member_birthdate'},
			{ text: 'Tanggal Input Member', value: 'member_input_datetime', sortable: true },
			],
			params:[],
			isLoading: false,
			filterData: [{
				type: 'text',
				label: 'Kode Member',
				value: 'code_member',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'member_network_mid'
				}
			}, {
				type: 'text',
				label: 'Nama Member',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'member_name'
				}
			}, {
				type: 'number',
				label: 'Nomor Hp',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'member_mobilephone'
				}
			}, {
				type: 'text',
				label: 'Email',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'member_email'
				}
			}, {
				type: 'selection',
				label: 'Jenis Kelamin',
				item: list_gender,
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'member_gender'
				}
			}, 
			// {
			// 	type: 'selection',
			// 	label: 'Status',
			// 	item: list_status,
			// 	filter: {
			// 		value: '',
			// 		comparison: '=',
			// 		type: 'string',
			// 		field: 'member_is_active'
			// 	}
			// },
			],
		}
	},
	computed: {
		...mapState(['filterParams']),
		...mapState('ecommerceMember', ['listMember', 'paginationMember', 'detailCustomer']),
	},
	methods: {
		...mapActions('ecommerceMember', ['getMember', 'exportMember', 'updateMember']),
		...mapMutations(['setFilter']),
		...mapMutations('ecommerceMember', ['clearDataMember']),

		getData() {
			this.getMember(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		exportData() {
			this.exportMember(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		async onResetFilter() {
			this.params = []
			this.getData()
		},
		editMember(item) {
			this.$refs.ModalEditMember.defineParams(item)
			this.$refs.ModalEditMember.showModal()
		},
		async resend(data) {
			let resend = await this.updateMember(data)
			if (resend == true)
				this.$refs.ModalEditMember.hideModal()
				this.getData()
		},
	},
	beforeDestroy(){
		this.clearDataMember()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Member Ecommerce`)
		await this.getData()

		await this.setFilter(this.filterData)
	},
};
</script>

<style>
